import { admin_question_edit_base } from './admin_question_edit_base';
export class admin_recruiting_question_edit extends admin_question_edit_base {
    getConfig() {
        return {
            moduleName: 'admin_recruiting_question_edit',
            headerTitle: 'Recruiting Question',
            referencesUrl: '/api/admin/rest/api/lead/recruiting/question/references/',
            questionUrl: '/api/admin/rest/api/lead/recruiting/question/',
            saveUrl: '/api/admin/rest/api/lead/recruiting/question/',
            deleteUrl: '/api/admin/rest/api/lead/recruiting/question/',
            listRoute: '/admin/recruitingQuestions',
            savedRoute: '/admin/recruitingQuestion/',
            missingSaveMessage: 'Unable to save recruiting question.',
            deleteConfirmMessage: 'Delete this recruiting question?',
            deleteErrorMessage: 'Unable to delete recruiting question.',
            templateOptions: {
                headerTitle: 'Recruiting Question',
                newTitle: 'New Recruiting Question',
                editTitle: 'Edit Recruiting Question',
                backLabel: 'Back to Available Questions',
                showDelete: true,
                showQuestionCode: false,
                showDisplayOrder: false,
            },
        };
    }
}
